module.exports = __webpack_public_path__ + "img/logo.95c13730.png";